/* eslint-disable */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Storage, API } from 'aws-amplify';
import { FormGroup, Label, Input, FormText, Card, CardHeader, CardBody, Row, Col, Button } from 'reactstrap';
import { Progress } from 'reactstrap';

import Icon from '@mdi/react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import AiPromptPopUp from './AiPromptPopUp';
import { mdiChatProcessingOutline } from '@mdi/js';

class AiButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openrewritepopup: false
        }
    }

    render() {
        return(
            // <div className='card_icon_div text-right'>
            <div class="">
                <Link to="#" className="badge text-bg-success float-right" onClick={() => this.setState({ openrewritepopup: true }) }>AI Assistant</Link>
                {this.promptModals()}
            </div>
        )
    }

    openRewritePopup = () => {
        this.setState(prevState => ({
            openrewritepopup: !prevState.openrewritepopup
        }))
    }

    promptModals = () => {
        //console.log('prompt');

        return(
            <div>
                <Modal
                    open={this.state.openrewritepopup}
                    onClose={this.openRewritePopup}
                    blockScroll={false}
                    closeOnOverlayClick={true}
                    styles={{
                        modal: {
                            width: "100%",
                            //overflowY: 'scroll',
                            maxHeight: "60%"
                        },
                    }}
                    center
                >
                    {/* {
                        this.props.name
                        ?
                        <AiPromptPopUp type={this.props.type} description={this.props.description} name={this.props.name} changeBio={this.props.changeBio} exit={this.openRewritePopup} />
                        :
                        <AiPromptPopUp type={this.props.type} description={this.props.description} editorState={true} changeBio={this.props.changeBio} exit={this.openRewritePopup} />
                    } */}

                    <AiPromptPopUp {...this.props} exit={this.openRewritePopup} />

                </Modal>                
            </div>
        )
    }
}

export default AiButton;